export const getUserGroupFromToken = (accessToken?: string) => {
  if (!accessToken) {
    return [];
  }
  const groups = JSON.parse(atob(accessToken.split('.')[1]))['cognito:groups'] as string[];

  return groups ? groups : [];
};

export const convertMillisecondsToHoursAndMinutes = (milliseconds: number) => {
  const SEC = 1e3;
  const MIN = SEC * 60;
  const HOUR = MIN * 60;
  const DAY = HOUR * 24;
  const ms = Math.abs(milliseconds);
  const h = ((ms % DAY) / HOUR) | 0;
  const m = ((ms % HOUR) / MIN) | 0;
  return {
    hours: h,
    minutes: m,
  };
};

export const convertSecondsToHoursAndMinutes = (seconds: string) => {
  return convertMillisecondsToHoursAndMinutes(parseInt(seconds) * 1000);
};
